// extracted by mini-css-extract-plugin
export default {"root":"classes_root__gBW8H","avatar":"classes_avatar__0B-x6","label":"classes_label__L17DW"};